import * as React from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export type AIQuestionBubbleProps = {
  text: string;
  sx?: SxProps<Theme>;
};

export function AIQuestionBubble({ text, sx }: Readonly<AIQuestionBubbleProps>) {
  return (
    <Box
      component="button"
      type="button"
      aria-label={text}
      data-testid="ai-question-bubble"
      sx={(theme) => ({
        alignSelf: 'flex-end',
        borderRadius: '16px 16px 0 16px',
        backgroundColor: '#1E212C',
        maxWidth: { xs: '85%', md: '70%' },
        boxShadow: '0 4px 8px rgba(0,0,0,0.25)',
        color: theme.palette.common.white,
        display: 'inline-flex',
        alignItems: 'center',
        padding: '16px 20px',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'background-color 160ms ease, transform 160ms ease, box-shadow 160ms ease',
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
        ...(sx as object),
      })}
    >
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          lineHeight: 1.35,
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
